"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.muiButtonColors = exports.buttonStyleVariants = void 0;
var _Theme = _interopRequireDefault(require("shared/dist/assets/Theme"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const buttonStyleVariants = exports.buttonStyleVariants = {
  "red-": {
    color: _Theme.default.palette.text.red,
    hover: {
      backgroundColor: _Theme.default.palette.background.hover.redLight
    }
  },
  "white-": {
    borderWidth: 2,
    borderStyle: "solid",
    backgroundColor: _Theme.default.palette.background.white,
    boxShadow: "0 0 1px 0 rgba(0,0,0,0.12), 0 1px 1px 0 rgba(0,0,0,0.24)"
  },
  "red-outlined": {
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: _Theme.default.palette.background.red,
    color: _Theme.default.palette.text.red,
    hover: {
      backgroundColor: _Theme.default.palette.background.hover.redLight
    }
  },
  "white-outlined": {
    borderWidth: 2,
    borderStyle: "solid",
    boxShadow: "0 0 1px 0 rgba(0,0,0,0.12), 0 1px 1px 0 rgba(0,0,0,0.24)",
    color: _Theme.default.palette.text.lightGrey,
    backgroundColor: "transparent",
    borderColor: _Theme.default.palette.background.white,
    hover: {
      backgroundColor: _Theme.default.palette.background.white,
      color: _Theme.default.palette.background.hover.dark
    }
  },
  "white-contained": {
    backgroundColor: _Theme.default.palette.background.white,
    boxShadow: "0 0 1px 0 rgba(0,0,0,0.12), 0 1px 1px 0 rgba(0,0,0,0.24)",
    color: _Theme.default.palette.text.darkGrey,
    hover: {
      borderColor: _Theme.default.palette.background.white,
      backgroundColor: "rgba(255,255,255,0.3)",
      color: _Theme.default.palette.background.white
    }
  },
  "purple-": {
    borderWidth: 2,
    borderStyle: "solid",
    color: _Theme.default.palette.text.white,
    backgroundColor: _Theme.default.palette.purple.main,
    hover: {
      backgroundColor: _Theme.default.palette.purple.light
    }
  }
};
const muiButtonColors = exports.muiButtonColors = {
  inherit: "inherit",
  primary: "primary",
  secondary: "secondary",
  success: "success",
  error: "error",
  info: "info",
  warning: "warning"
};